module.exports = __webpack_public_path__ + "static/media/humas.11804200.png";